<div *ngIf="!selectedReport">
	<div class="card h-100 p-0">
		<div class="d-flex flex-column">
			<div class="d-flex">
				<div class="h3 mx-4 mt-2 mb-1">Reports</div>
			</div>
			<p-divider></p-divider>
			<ng-container *ngFor="let category of reportCategory">
				<app-reports-categories
					[category]="category"
					[reports]="reports.value | arrayFilter: { category: category }"
					[(reportSelected)]="selectedReport"
				></app-reports-categories>
			</ng-container>
		</div>
	</div>
</div>

<div *ngIf="selectedReport" class="card">
	<div class="d-flex mb-3">
		<div class="h4 ms-2">{{ selectedReport.name }}</div>
		<fa-icon [icon]="['far', 'times-circle']" class="ms-auto" size="2x" (click)="selectedReport = undefined"></fa-icon>
	</div>
	<app-internet-history-report *ngIf="selectedReport.key === '8a1b0dee-198b-4bb8-b5d8-8407ad1d5082'" [(report)]="selectedReport">
	</app-internet-history-report>
	<app-report-future-order-item *ngIf="selectedReport.key === 'fc9229e9-04b7-4bce-b4db-199999500910'" [(report)]="selectedReport">
	</app-report-future-order-item>
	<app-product-use-report
		*ngIf="selectedReport.key === 'c04f1ccd-0063-49db-9a30-d3047f597cb0'"
		productOption="onlineorder"
		[(report)]="selectedReport"
	></app-product-use-report>
	<app-product-bubble-chart *ngIf="selectedReport.key === 'cc0a1914-fefa-4b1a-b348-9201706ba3a0'" [(report)]="selectedReport"></app-product-bubble-chart>
	<app-daily-sales-report *ngIf="selectedReport.key === '895d7557-2bd9-4353-9537-a07da48c4880'" [(report)]="selectedReport"></app-daily-sales-report>
	<app-tip-pool-report *ngIf="selectedReport.key === '1f1e0b69-47ec-4dca-b180-37bb8f7fe754'" [(report)]="selectedReport"></app-tip-pool-report>
	<app-table-performance-report
		*ngIf="selectedReport.key === '84165097-d21e-432f-bf1e-9d76253cb5e9'"
		[(report)]="selectedReport"
	></app-table-performance-report>
</div>
